import { theme } from '_constants/theme';
import styled from 'styled-components';
import React from 'react';
import { ICONS_ALIASES } from '_constants/icons';
import Icon from '_components/atomic/Icon';

const { colors, devices, fontSizes, spaces } = theme;

const StyledWhyTrademarkMonitoringRight = styled.div`
  width: 100%;
  padding: ${spaces.large4X}px;
  gap: ${spaces.large4X}px;
  background-color: ${colors.white};
  box-shadow: 0px 10px 80px rgba(0, 0, 0, 0.05);
  border-radius: 50px;
  .headerRightTrademark {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large2X}px;
    line-height: 150%;
    text-align: justify;
    color: ${colors.gray[700]};
    margin-bottom: ${spaces.large4X}px;
  }
  .listRightTrademark {
    width: 100%;
    gap: ${spaces.medium}px;
    display: flex;
    flex-direction: column;
  }
  @media ${devices.tablet} {
    border-radius: 0px;
    padding: 0;
    gap: ${spaces.large2X}px;
    .headerRightTrademark {
      padding-left: ${spaces.regular}px;
      padding-right: ${spaces.regular}px;
      font-size: ${fontSizes.regular}px;
      text-align: center;
      margin-bottom: ${spaces.large2X}px;
    }
    .listRightTrademark {
      padding: ${spaces.regular}px;
      background: ${colors.white};
    }
  }
`;
const StyledProduct = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaces.medium}px;
  background: ${({ color }) => color};
  border-radius: 16px;
  padding: ${spaces.medium}px;
  flex-direction: row;
  align-items: center;
  svg {
    width: 40px;
    height: 40px;
  }
  .description {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large}px;
    line-height: 150%;
    color: ${({ textColor }) => textColor};
  }
  @media ${devices.tablet} {
    svg {
      width: 32px;
      height: 32px;
    }
    .description {
      font-size: ${fontSizes.regular}px;
    }
  }
`;
const products = [
  {
    header: 'Thorough monitoring searches through millions of pages',
    icon: `${ICONS_ALIASES.searchNormal}`,
    color: `${colors.blue[50]}`,
    textColor: `${colors.blue[500]}`,
  },
  {
    header: 'Protect your mark from unwanted use',
    icon: `${ICONS_ALIASES.shield}`,
    color: `${colors.purple[25]}`,
    textColor: `${colors.purple[500]}`,
  },
  {
    header: 'Keep tabs on your competition',
    icon: `${ICONS_ALIASES.saveAdd}`,
    color: `${colors.green[25]}`,
    textColor: `${colors.green[500]}`,
  },
];
const RightPartWhyTrademarkMonitoringSection = () => {
  return (
    <StyledWhyTrademarkMonitoringRight>
      <div className="listRightTrademark">
        {products.map((step, idx) => {
          const { header, icon, color, textColor } = step;
          return (
            <StyledProduct key={idx} color={color} textColor={textColor}>
              <div>
                <Icon alias={icon} color={textColor} />
              </div>
              <div className="description">{header}</div>
            </StyledProduct>
          );
        })}
      </div>
    </StyledWhyTrademarkMonitoringRight>
  );
};

export default RightPartWhyTrademarkMonitoringSection;
